export class UnauthorizedError extends Error {
  override readonly name = 'UnauthorizedError';
  constructor() {
    super('Unauthorized');
  }
}

export class NetworkError extends Error {
  override readonly name = 'NetworkError';
  constructor() {
    super('Network error');
  }
}

export class ServerError extends Error {
  override readonly name = 'ServerError';
  constructor() {
    super('Server error');
  }
}

export class InvalidSettingsInputError extends Error {
  override readonly name = 'InvalidSettingsInputError';
  constructor(message = 'Invalid settings input') {
    super(message);
  }
}

export type SettingsError =
  | UnauthorizedError
  | NetworkError
  | ServerError
  | InvalidSettingsInputError;
